<template>
  <div>
    <CCard class="p-0 m-0 form-card">
      <CCardHeader>
        <label class="header-title">機器一覧</label>
        <div class="card-header-actions" v-if="$store.state.user.role == 'ADMINISTRATOR' || $store.state.user.role == 'REGISTRATOR'">
          <CButton color="info" size="sm" class="mr-3" @click="sampleDownload()">テンプレートダウンロード</CButton>
          <CButton color="primary" size="sm" @click="isCollapsed=!isCollapsed">{{isCollapsed ? '登録':'一覧'}}モードへ</CButton>
        </div>
      </CCardHeader>
      <CCardBody class="p-0 m-0">
        <CCollapse :show="!isCollapsed" :duration="200">
            <CRow class="px-0 mx-0">
              <CCol class="col-6">
                <CSelect label="機器登録"
                         autocomplete="device kind"
                         :value="formValue.deviceKind"
                         @update:value="formValue.deviceKind = $event"
                         :options="deviceOptions"/>
              </CCol>
              <CCol class="col-4">
                <CInputFile label="ファイル" autocomplete="file" inline
                            @change="formValue.file = $event[0]"/>
<!--                <CInputFile-->
<!--                    ref="file"-->
<!--                    custom-->
<!--                    prepend="@"-->
<!--                    @change="fileChange"-->
<!--                    label="123123"-->
<!--                    :placeholder="formValue.file == null  ? 'ファイルを選択してください' : formValue.file.name">-->
<!--                </CInputFile>-->
              </CCol>
            </CRow>
            <CRow class="px-0 mx-0">
              <CCol class="text-right">
                <CButton color="danger" size="sm" class="mb-2" @click="upload">登録</CButton>
              </CCol>
            </CRow>
        </CCollapse>
      </CCardBody>
    </CCard>
    <CCard class="p-0 m-0 grid-card">
      <Device ref="device" :show-lost-discard="showLostDiscard" :show-download="true" :is-device-list="true"
              @lost="lost"  @discard="discard" :is-collapsed-nested="isCollapsed" open-height="58vh"></Device>
    </CCard>
  </div>
</template>

<script>

import Device from "@/component/Device";
// import BeeMix from '@/views/aprod/js/mixin/beeUtils'
export default {
  name: 'DeviceList',
  // mixins:[BeeMix],
  components:{
    Device
  },
  data() {
    return {
          requestDate: '',
          searchParams:{},
          searchTargets: [],
          deviceOptions: [
            {value: 'TCL-003', label: 'IoTゲートウェイ(TCL-003*.csv)'},
            {value: 'UA-651BLE', label: '血圧計(UA-651BLE*.csv)'},
            {value: 'TM1121', label: 'パルスオキシメータ(TM1121*.csv)'},
            {value: '5A+', label: '酸素濃縮装置(5A+*.csv)'},
            {value: '5B+', label: '酸素濃縮装置(5B+*.csv)'}
          ],
          isCollapsed:true,
          formValue: {deviceKind: "TCL-003"},
          showLostDiscard:this.$store.state.user.role == 'ADMINISTRATOR' || this.$store.state.user.role == 'REGISTRATOR',
          searchBarPlaceHolder:"氏名、販売店、販売店ID、シリアル番号、BDアドレス、登録Noで検索"
    }
  },
  mounted() {
    // this.showLostDiscard = ;
  },
  methods: Object.assign({}, {
    fileChange:function(files,event){
      this.formValue.file = files[0];
    },
    // detail(data) {
    //   // console.log(data);
    //   // this.$router.push({name: 'AgencyUsers', params: {data: data.item}});
    // },
    lost:function(lostFlg,deviceId){
      this.$swal({title:"確認",text:`紛失${lostFlg ? '解除':'登録' }処理を行いますか？`,buttons:true,dangerMode:true}).then((result) => {
        if (result) {
          this.axios.post("/api/device/lost_discard",
              {deviceId:deviceId,lostFlg:!lostFlg}
              , {
                headers: {"Content-Type": "application/json"}
              }
          ).then(response => {
            console.log('response', response);
            this.goodPaging();
          }).catch(error => {
            console.log('error', error);
          }).finally(() => {
            console.log('finally');
          });
        }
      });
    },
    discard:function(discardFlg,deviceId){
      this.$swal({title:"確認",text:`廃棄${discardFlg ? '解除':'登録' }処理を行いますか？`,buttons:true,dangerMode:true}).then((result) => {
        if (result) {
          this.axios.post("/api/device/lost_discard",
              {deviceId:deviceId,discardFlg:!discardFlg}
              , {
                headers: {"Content-Type": "application/json"}
              }
          ).then(response => {
            console.log('response', response);
            this.goodPaging();
          }).catch(error => {
            console.log('error', error);
            console.log('error', error.response.data);
          }).finally(() => {
            console.log('finally');
          });
        }
      });
    },
    columnFilterFn:function(data){
      console.log("columnFilterFn",data);
    },
    upload() {
      this.$swal({title:"アップロード確認",text:"アップロードしますか？",buttons:true,dangerMode:true}).then((result) => {
        if (result) {
          delete this.formValue["__ob__"];
          let formData = new FormData();
          formData.append("deviceKind", this.formValue.deviceKind);
          formData.append("file", this.formValue.file);
          if (this.formValue.file == null) {
            this.$swal("ファイルを指定してください。");
            return;
          }

          this.axios.post("/api/deviceUpload",
              formData
              , {
                headers: {"Content-Type": "multipart/form-data"}
              }
          ).then(response => {
            console.log('response', response);
            this.goodPaging();
          }).catch(error => {
            console.log('error', error);
          }).finally(() => {
            console.log('finally');
          });
        }
      });

    },
    goodPaging(isPageChange) {
      this.$refs.device.goodPaging(isPageChange);
    },
    changeCheckBox(data, checkValue) {
      data.item.checked = checkValue;
      this.$set(this.items, data.index, data.item);
    },sampleDownload(){
      this.axios.post('/api/device/sample/download',
          this.searchParams
          , {headers: {'Content-Type': 'application/json'}, responseType: 'blob'}).then(
          response => {
            let url = window.URL.createObjectURL(new Blob([response.data]));
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', decodeURI(response.headers.filename));
            document.body.appendChild(link);
            link.click();
          }).catch(error => console.log(error)
      ).finally(() => this.isLoading = false);
    },
  }),
}
</script>
